const DEFAULT_SEGMENT_LENGTH = 36;

const DetailUtils = {
  separateSynopsis(synopsis: string) {
    if (!synopsis) {
      return;
    }

    const words = synopsis.split(' ');
    const segmentedSynopsis: string[] = [];

    while (words.length > 0) {
      let segmentLength = DEFAULT_SEGMENT_LENGTH;

      while (
        segmentLength < words.length &&
        /[^\w\d]/g.test(words[segmentLength - 1].slice(-1))
      ) {
        segmentLength += 3;
      }

      segmentedSynopsis.push(words.splice(0, segmentLength).join(' '));
    }

    if (
      segmentedSynopsis.length > 1 &&
      segmentedSynopsis[segmentedSynopsis.length - 1].split(' ').length < 5
    ) {
      segmentedSynopsis[segmentedSynopsis.length - 2] +=
        ' ' + segmentedSynopsis.pop();
    }

    return segmentedSynopsis.map((string, index) => {
      return string.concat(index < segmentedSynopsis.length - 1 ? '...' : '');
    });
  },
};

export default DetailUtils;
